import { Component, Injector } from '@angular/core';
import { routes as routesCatalog } from 'src/app/utils/catalog';
import { FormLoading } from '../../forms/base-form/base-form.component';
import { BasePageComponent } from '../base-page/base-page.component';
import { ObjectService } from 'src/app/services/object.service';
import { SessionModel } from 'src/app/models/session-model';
import { ModelFactory } from 'src/app/models/model-factory';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
})
export class LoginPageComponent extends BasePageComponent {
  constructor(injector: Injector, private objectService: ObjectService) {
    super(injector);
  }

  async handleLogin({ values, formLoading }: { values: any; formLoading: FormLoading }): Promise<void> {
    formLoading.start();
    try {
      const session = await this.authService.login(values);
      if (!this.objectService.addObject(ModelFactory.newInstance(SessionModel, session))) this.objectService.updateObject(session);
      await this.router.navigateByUrl(routesCatalog.dispatcher.url, { replaceUrl: true });
    } finally {
      formLoading.stop();
    }
  }
}
